import LTR from "@brand-icons/global/social-telegram/social-telegram-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialTelegramIcon = iconFactory("SocialTelegramIcon", LTR);
